import * as APP from "@/utils/appRequest";
import * as API from "@/utils/apiRequest";
import * as APIS from "@/utils/apisRequest";
import * as QUOTE from "@/utils/quoteRequest";
export default {
    async userLogin(opt) {
        let res = await APP.post({
            url: "/v1/user/login",
            params: {
                ...opt
            }
        });
        return res;
    },

    // 获取投顾老师的信息
    async getTeacherInfo(opt) {
        let res = await APP.get({
            url: "/api2/details.php",
            params: {
                ...opt,
                act: "liver_detail",
            }
        });
        return res;
    },

    // 获取投顾老师主页背景图
    async getImage(opt) {
        let res = await APP.get({
            url: "/v2/userBackgroundImage/getImage",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 获取主页列表接口
    // https://app.aigupiao.com/api2/live_center_v3.php?act=msg&appversion=11.7.0&bundle_name=love_stock_pro&division=3&id=120&igptoken=ZmU4MDo6YzlhYToxZDNkOjY1Zjk6ZTM5N18xNzE2NzkyMTg4XzE3MTY3OTE1ODhfZGRjZWU5OTQ1MTcwMDZmZjM2ZmJjZTY1MTFlNGM3YTc%3D&lgStatus=531856593dd2bd769082e276ab38b6d4&love_stock_pro_is_show_all=1&mds=531856593dd2bd769082e276ab38b6d4&origin_user_id=0&sign=166f11cd89f67b7448b53d139544fa80&source=ios&time=1716791588&u_id=44324&user_id=44324&vtoken=d816f2ad4b756935d22abe2a5c5363e5
    async getLiveCenter(opt) {
        let res = await APP.get({
            url: "/api2/live_center_v3.php",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 获取直播预告信息
    // http:appbeta.aigupiao.com/goapi/room/preview_info?room_l_id=46&room_u_id=44324
    async getPreviewInfo(opt) {
        let res = await APP.get({
            url: "/goapi/room/preview_info",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 获取直播
    async getLiveInfo(opt) {
        let res = await APP.get({
            url: "/room/getIsLiveInfo",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 获取模拟炒股 TODO: c_u_id u_id 取反 u_id才是查看用户的id c_u_id是当前用户的ID
    // https://apisdev.aigupiao.com/HsReplicaAcc/profits?c_u_id=24&u_id=24&user_id=24&location=homepage&hs_version=2&u_type=_self
    async getProfits(opt) {
        let res = await APIS.get({
            url: "/HsReplicaAcc/profits",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 获取模拟大赛
    // https://appdev.aigupiao.com/goapi/match/info?close_pay=no&origin_user_id=0&device_id=3519f1e15df92a4d142bcab0569cc668b4f5506853e3fcec80e5c18e07e76e6d&device_model=V2002A&sign=9a093c84d255c2aef78341914fda1baf&appversion=11.5.2&channel_code=Channel_dev&source=android&vtoken=6b3880be4dd0add32b95d750eb37091e&u_id=24&device_brand=vivo&igptoken=MTI3LjAuMC4xXzE3MTcwNTY2MzRfMTcxNzA1NjAzNF9kZGNlZTk5NDUxNzAwNmZmMzZmYmNlNjUxMWU0YzdhNw%3D%3D&user_id=24&view_user_id=24&time=1717056034&mds=8270551c8f6db31d0a0e5ebdebd53573
    async getMatchInfo(opt) {
        let res = await APP.get({
            url: "/goapi/match/info",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 获取战绩榜
    // https://apis.aigupiao.com/SysNotice/liver_notice/
    async getLiverNotice(opt) {
        let res = await APIS.get({
            url: "/SysNotice/liver_notice/",
            params: {
                ...opt
            }
        })
        return res;
    },
    // 获取推荐关注列表
    // https://apis.aigupiao.com/sliders/pc_recommend?close_pay=no&origin_user_id=0&device_id=3519f1e15df92a4d142bcab0569cc668b4f5506853e3fcec80e5c18e07e76e6d&device_model=V2002A&sign=95c6bba2f6ba583f3f878c42fa45f5cd&appversion=11.5.2&source=app&channel_code=Channel_dev&vtoken=51224400f5f51e00fcba6fe97000d791&u_id=24&device_brand=vivo&igptoken=MTI3LjAuMC4xXzE3MTc0MTYyMjZfMTcxNzQxNTYyNl9kZGNlZTk5NDUxNzAwNmZmMzZmYmNlNjUxMWU0YzdhNw%3D%3D&pagesize=20&page=1&time=1717415626&mds=531856593dd2bd769082e276ab38b6d4
    async getPcRecommend(opt) {
        let res = await APIS.get({
            url: "/sliders/pc_recommend",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 关注 老师主页关注： act: unfollow 取消关注 act: follow 关注 id 关注对方的ID
    // https://app.aigupiao.com/api/live.php?u_id=24&act=follow&user_id=24&id=57
    async setFollowLive(opt) {
        let res = await APP.get({
            url: "/api/live.php",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 关注 用户主页关注： act: unfollow 取消关注 act: follow 关注 id 关注对方的ID
    // https://app.aigupiao.com/api/user.php?u_id=24&act=follow&user_id=24&id=57
    async setFollowUser(opt) {
        let res = await APP.get({
            url: "/api/user.php",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 投票接口
    // api.aigupiao.com/v1/vote/select
    async setVoteSelect(opt) {
        let res = await API.get({
            url: "/v1/vote/select",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 股票类型 - 离岸人民币
    async getUSDCNH(opt) {
        let res = await APIS.get({
            url: "/USDCNH/USDCNH_s",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 股票类型 - 美元指数
    // http://apisbeta.aigupiao.com/DINIW/DINIW_s
    async getDINIW(opt) {
        let res = await APIS.get({
            url: "/DINIW/DINIW_s",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 股票类型 - 富时A50 QUOTE
    async getA50(opt) {
        let res = await QUOTE.get({
            url: "/api/query.php",
            params: {
                ...opt,
                list: "A50"
            }
        })
        return res;
    },

    // 股票类型 - 港美股 QUOTE
    async getHKUS(opt) {
        let res = await QUOTE.get({
            url: "/api4/istock/MarketDataClient.php",
            params: {
                ...opt,
                act: "detail"
            }
        })
        return res;
    },

    // 股票类型 - A股 QUOTE
    async getAStock(opt) {
        let res = await QUOTE.get({
            url: "/api/query.php",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 获取视频
    // https://apis.aigupiao.com/LiveHomeVideo/video_list?number=10&u_id=24&user_id=24&before=&l_id=46&version=375
    async getVideoList(opt) {
        let res = await APIS.get({
            url: "/LiveHomeVideo/video_list",
            params: {
                ...opt
            }
        });
        return res;
    },

    // 获取自选列表
    // https://app.aigupiao.com/api2/user_stock.php?u_id=24&cuser_id=44324&act=get_stock_list&user_id=24&format=json&type=edit_all&version=3
    async getUserStock(opt) {
        let res = await APP.get({
            url: "/api2/user_stock.php",
            params: {
                ...opt
            }
        });
        return res;
    },

    // 点赞接口
    // https://app.aigupiao.com/api/attitude.php?act=publish&appversion=11.7.0&bundle_name=love_stock_pro&id=2778033&igptoken=ZmU4MDo6N2VkMzozMmMwOmI4NWU6OGZkXzE3MTc3NDE3NTNfMTcxNzc0MTE1M19kZGNlZTk5NDUxNzAwNmZmMzZmYmNlNjUxMWU0YzdhNw%3D%3D&kind=live_msg&lgStatus=d79c720d061667bfc68b081e02133e92&love_stock_pro_is_show_all=1&mds=d79c720d061667bfc68b081e02133e92&sign=f0c31ed24e65e140278357f4db0ae1f6&source=ios&time=1717741153&type=support&u_id=83184&user_id=83184&vtoken=c041c8b315ead3635f70407e39534ac5
    async setAttitude(opt) {
        let res = await APP.get({
            url: "/api/attitude.php",
            params: {
                ...opt
            }
        })
        return res;
    },

    // 关注组合
    // https://apis.aigupiao.com/UserStock/stock_follow/
    async setStockFollow(opt) {
        let res = await APIS.get({
            url: "/UserStock/stock_follow",
            params: {
                ...opt
            }
        });
        return res;
    },

    // 获取评论 getTeacherInfo
    async getComment(opt) {
        let res = await APP.get({
            url: "/api2/comment.php",
            params: {
                ...opt,
                act: "list",
            }
        });
        return res;
    },

    // 预约直播预告
    // https://app.aigupiao.com/goapi/room/reserve
    async setReserve(opt) {
        let res = await APP.post({
            url: "/goapi/room/reserve",
            params: {
                ...opt
            }
        });
        return res;
    },
    // 详情页 - 会员帖
    // https://app.aigupiao.com/api2/live_msg.php?act=msg_detail&appversion=11.6.0&bundle_name=love_stock_pro&igptoken=ZmU4MDo6ODJlNjpmMDM2OmZiZjM6MTlfMTcxODM2MDkwOF8xNzE4MzYwMzA4X2RkY2VlOTk0NTE3MDA2ZmYzNmZiY2U2NTExZTRjN2E3&lgStatus=bc05b08f05efa4bd67d4d7b494987af0&love_stock_pro_is_show_all=1&m_id=2779380&mds=bc05b08f05efa4bd67d4d7b494987af0&newest=yes&origin_user_id=0&sign=e221a1b2902aafd88c5eba0cf311444c&source=ios&time=1718360308&u_id=77272&user_id=77272&version=390&vtoken=c394461c56a24ef98718bd8e72ddee7a
    async getLiveMsg(opt) {
        let res = await APP.get({
            url: "/api2/live_msg.php",
            params: {
                ...opt
            }
        });
        return res;
    },

    // 取消拉黑用户
    // https://apisdev.aigupiao.com/Comment/change_black
    async setChangeBlack(opt) {
        let res = await APIS.get({
            url: "/Comment/change_black",
            params: {
                ...opt
            }
        })
        return res;
    },
    async getForumListAllData(opt) {

    },
    async getCircleData(opt) {
        
    },
    // 聊天室 发送消息
    async send_message(opt) {
        let res = await APP.post({
            url: "/goapi/chat_room/send_message",
            params: {
                ...opt
            }
        })
        return res;
    },
    // 聊天室 删除 撤回消息
    async delete_message(opt) {
        let res = await APP.post({
            url: "/goapi/chat_room/delete_message",
            params: {
                ...opt
            }
        })
        return res;
    },
    // 聊天室 - 拉黑用户
    async add_black(opt) {
        let res = await APP.post({
            url: "/goapi/chat_room/add_black",
            params: {
                ...opt
            }
        })
        return res;
    },
    // 聊天室 - 获取列表
    async get_chat_list(opt) {
        let res = await APP.post({
            url: "/goapi/chat_room/get_chat_list",
            params: {
                ...opt
            }
        })
        return res;
    },
    // 聊天室 - 获取列表 - 直播式
    async get_new_chat_list(opt) {
        let res = await APP.post({
            url: "/goapi/chat_room/get_new_chat_list",
            params: {
                ...opt
            }
        })
        return res;
    },
    // 聊天室 - 直播室聊天室 消息审核
    async audit_chat_message(opt) {
        let res = await APP.post({
            url: "/goapi/chat_room/audit_chat_message",
            params: {
                ...opt
            }
        })
        return res;
    },
    // 聊天室 - 获取聊天室 信息
    async get_chat_room_status(opt) {
        let res = await APP.post({
            url: "/goapi/chat_room/get_chat_room_status",
            params: {
                ...opt
            }
        })
        return res;
    },
    // 聊天室 - 设置样式以及禁言
    async set_chat_room_status(opt) {
        let res = await APP.post({
            url: "/goapi/chat_room/set_chat_room_status",
            params: {
                ...opt
            }
        })
        return res;
    },

    //https://appdev.aigupiao.com/goapi/live/get_company_wap?live_id=46&source=wap&user_id=335247
    async get_company_wap(opt) {
        let res = await APP.get({
            url: "/goapi/live/get_company_wap",
            params: {
                ...opt,
            }
        });
        return res;
    },

};
